<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-02">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-nowrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Database adapter</h1>

                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">
                            <p class="mu-mb-00">
                                {{ (isEditPage) ? helpTextEdit.title : helpTextCreate.title }}
                                <a :href="helpTextCreate.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group" v-if="isEditPage">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportAdapter()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>

                    </div>

                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Integrate</li>
                <li>
                    <a class="table-link" @click="redirectToList()">External systems</a>
                </li>
                <li>
                    <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystem.name}}</router-link>
                </li>
                <li>
                    <a class="table-link" @click="redirectToFileAPI()">{{externalSystemAPI.name}}</a>
                </li>

                <li aria-current="page">{{(isEditPage) ? sqlAdapterName : 'Create new'}}</li>

                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
        <div class="mcc-row" v-show="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>

        <div style="position:relative">
            <div v-if="!updateCall" class="spinner-overlay">
                <div class="spinner-background"></div>
                <div class="spinner-flex">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-row" v-show="fetchCall">
                <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly" color="warning">
                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                        <p>
                            <strong>Warning!</strong>
                            <br />{{readOnlyMsg}}
                            <br />
                        </p>
                    </mcc-alert>

                </div>

                <div class="mcc-card ">
                    <div class="mcc-card__body">
                        <form id="sqlAdapterForm" ref="sqlAdapterForm" @submit.prevent="saveSQLAdpater()" novalidate>
                    <div class="mcc-row">
                        <div class="mcc-col mcc-col-12 mcc-col-md-6">

                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Configuration</h2>
                                    </div>

                                    <div class="mcc-card__body">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                                    <label for="name" class="mu-mb-00 mfc-label--required">Name</label>
                                                    <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="sqlAdapterDTO.name" :pattern="nameRegex" @change="updateName($event)">

                                                </div>
                                                <div class="mfc-input-wrapper  mu-d-block mfc-form-input-container mu-mb-05">
                                                    <label for="adapterPrefix" class="mu-mb-00 mfc-label--required">Prefix</label>
                                                    <input type="text" id="adapterPrefix" name="adapterPrefix" required="" placeholder="Prefix" maxlength="50" :disabled="isReadOnly" ref="adapterPrefix" :value="sqlAdapterDTO.adapterPrefix" :pattern="nameRegex" @change="updatePrefix($event)">

                                                </div>

                                                <div class="mcc-segmented-buttons mcc-segmented-buttons--sm mu-mb-05 mfc-form-input-container">
                                                    <fieldset class="mfc-fieldset">
                                                        <legend class="mfc-label mfc-label--required">
                                                            Type
                                                        </legend>
                                                        <div class="mcc-segmented-buttons__list " :value="sqlAdapterDTO.sqlMethod" @change="sqlAdapterDTO.sqlMethod = $event.target.value" block ref="sqlMethod" name="sqlMethod" id="sqlMethod">
                                                            <input type="radio" name="view" id="day" ref="input" required :disabled="isReadOnly" :checked="sqlAdapterDTO.sqlMethod === 'SELECT'" value="SELECT">
                                                            <label class="mcc-segmented-buttons__button" for="day">
                                                                <span class="mcc-segmented-buttons__label">SELECT</span>
                                                            </label>
                                                            <input type="radio" name="view" id="week" required :disabled="isReadOnly" :checked="sqlAdapterDTO.sqlMethod === 'UPDATE'" value="UPDATE">
                                                            <label class="mcc-segmented-buttons__button" for="week">
                                                                <span class="mcc-segmented-buttons__label">UPDATE</span>
                                                            </label>
                                                        </div>
                                                        <div class="mfc-invalid-feedback mfc-invalid-feedback--show"></div>
                                                    </fieldset>
                                                </div>
                                                <div class="mfc-textarea-wrapper mfc-form-input-container" character-count="">
                                                    <label for="sql" class="mfc-label--required">SQL</label>
                                                    <textarea required="" id="sql" rows="6" name="sql" maxlength="100000" :disabled="isReadOnly" :value="sqlAdapterDTO.sql" @input="updateParams($event)" ref="sql" placeholder="SQL"></textarea>
                                                    <div class="mfc-invalid-feedback"></div>
                                                    <div class="mfc-help-text mu-mt-00">
                                                        <span v-if="sqlAdapterDTO.sql">You have {{100000 - sqlAdapterDTO.sql.length}} characters remaining</span>
                                                        <span v-else>You have 100000 characters remaining</span>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                           

                        </div>
                        <div class="mcc-col mcc-col-12 mcc-col-md-6">
                            <div class="mcc-card fullHeightCard">
                                <div class="mcc-card__header">
                                    <h2 class="mcc-card__title">Parameter types</h2>
                                </div>

                                <div class="mcc-card__body">
                                    <div>
                                        <div class="mcc-row" v-for="(item, index) in sqlAdapterDTO.sqlParameterTypes" :key="index+item.fieldName">
                                            <div class="mcc-col-8">
                                                <div class="mfc-select-wrapper">
                                                    <label for="mds_select" class="mu-mb-00">{{item.fieldName}}</label>
                                                    <select class="mu-mb-04" :disabled="isReadOnly" :id="'sqlParamsTypeCmp' + index" @change="item.fieldType = $event.target.value" help-text :data-value="item.fieldType">
                                                        <option :selected="item.fieldType === 'STRING'" value="STRING">String</option>
                                                        <option :selected="item.fieldType === 'BOOLEAN'" value="BOOLEAN">Boolean</option>
                                                        <option :selected="item.fieldType === 'DOUBLE'" value="DOUBLE">Double</option>
                                                        <option :selected="item.fieldType === 'FLOAT'" value="FLOAT">Float</option>
                                                        <option :selected="item.fieldType === 'INT'" value="INT">Int</option>
                                                        <option :selected="item.fieldType === 'LONG'" value="LONG">Long</option>
                                                        <option :selected="item.fieldType === 'DATE'" value="DATE">Date</option>
                                                        <option :selected="item.fieldType === 'TIME'" value="TIME">Time</option>
                                                        <option :selected="item.fieldType === 'TIMESTAMP'" value="TIMESTAMP">Timestamp</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="mcc-col mu-mt-07">
                                                <div class="mfc-checkbox-wrapper mfc-form-input-container" :disabled="isReadOnly" :id="'sqlParamsTypeCmpMandatory' + index" :name="'sqlParamsTypeCmpMandatory' + index" :checked="item.mandatory" @change="item.mandatory = $event.target.checked" color="primary">
                                                    <input type="checkbox" id="mandatory" class="mfc-switch">
                                                    <label for="mandatory">Mandatory</label>

                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                        <div class="mu-d-flex mu-justify-content-end mu-mt-05">
                            <div role="group" class="mcc-button-group mcc-button-group--spaced mcc-button-group-flex-wrap">
                            <button type="button" class="mcc-button mcc-button--soft-danger" v-if="isEditPage && !isReadOnly" id="deleteSqlAdapterBtn" @click="showDeleteAdapterDialog()" title="Delete">
                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                            </button>
                            <router-link v-if="isEditPage && !isReadOnly" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id+'/sqladapters/new?copyAdapterId='+sqlAdapterDTO.id" class="mu-mr-05">
                                <button class="mcc-button  mcc-button--outline" id="copyBtn" title="Copy">
                                    <mcc-icon name="copy" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Copy</span>
                                </button>
                            </router-link>
                            <router-link v-if="!isEditPage" :to="copyAdapter ? CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id + '/sqladapters/'+ copyAdapterId : CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId+'/apis/'+externalSystemAPI.id" class="mu-mr-05">
                                <button type="button" class="mcc-button mcc-button--outline " id="cancelBtn" title="Cancel">
                                    <mcc-icon name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                </button>
                            </router-link>
                            <button type="button" class="mcc-button  mcc-button--outline" id="testSqlBtn" @click="showTestAdapterDialog()" title="Test SQL">
                                <mcc-icon name="connected" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Test SQL</span>
                            </button>

                            <button class="mcc-button mcc-button--success" v-if="!isReadOnly" id="saveBtn" title="Save" type="submit" >
                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                            </button>
                        </div>
                        </div> 
                   
                </form>
                </div>
            </div>

            </div>
        </div>

   
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" color="danger" ref="deleteSqlAdapter" id="deleteSqlAdapter">
            <form  @submit.prevent="deleteSqlAdapter($event)" novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h4 class="h4">Delete database adapter</h4>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteSqlAdapter.close()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        Are you sure you want to delete database adapter?
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteSqlAdapter.close()">No</button>
                            <button type="submit" class="mcc-button mcc-button--danger">Yes</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
    <div class="mcc-dialog-overlay">
        <dialog :class="['mcc-dialog', 'mcc-dialog--primary', 'mcc-dialog--xs']" ref="failedSqlAdapter" id="failedSqlAdapter">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h4 class="h4">Test adapter</h4>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.failedSqlAdapter.close()">
                            <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label">Button</span>
                        </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-col">
                            <div v-if="sqlTestResult != ''">Result</div>
                            <span id="sqlresultMsg">{{sqlTestResult}}</span>

                        </div>

                        <div class="mcc-row" v-show="fetchGridData">
                            <div class="mcc-col colSpinner">
                                <div class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="mcc-row" v-show="!fetchGridData">
                            <div class="mcc-col mcc-col-md-12">
                                <div style="position:relative">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <mcc-data-table ref="resultDataTable" id="resultDataTable"></mcc-data-table>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="mcc-dialog__footer">

                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--primary" @click="testAdapter(true)">Test again</button>
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.failedSqlAdapter.close()">Close</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>

    <div class="mcc-dialog-overlay">
        <dialog :class="['mcc-dialog', 'mcc-dialog--primary', 'mcc-dialog--sm']" @close="params = []" ref="testAdapterDialog" id="testAdapterDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h4 class="h4">Test adapter</h4>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.testAdapterDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <form ref="testAdapterDialogFormRef" novalidate>

                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning" v-show="sqlAdapterDTO.sqlMethod == 'UPDATE'">
                            <mcc-icon name="error" aria-hidden="true" icon-set="fluency-filled"></mcc-icon>
                            <span class="mu-fw-semi-bold">Testing UPDATE method will change data in the end system. Ensure you understand the implications before clicking the Test button.</span>
                        </mcc-alert>
                        <div class="mcc-row">
                            <div class="mcc-col">

                                <details class="mcc-accordion" v-if="sqlAdapterDTO.sqlParameterTypes.length > 3">
                                    <summary>
                                        <span class="mcc-accordion__label">Input lines</span>
                                        <mcc-icon class="mcc-accordion__caret mu-ml-auto" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                    </summary>
                                    <div class="mcc-accordion__body">
                                        <div class="mfc-input-wrapper mfc-form-input-wrapper--width-popup mu-d-block paraminpopup mfc-form-input-container" :id="'param_'+index" v-for="(item, index) in sqlAdapterDTO.sqlParameterTypes" :key="index" :label="item.fieldName">
                                            <label :for="'param_' + index">{{item.fieldName}}</label>
                                            <input type="text" value="" class="mu-mb-02" :id="'param_' + index">
                                            <div class="mfc-help-text"></div>

                                        </div>
                                    </div>
                                </details>
                                <div v-else>
                                    <div class="mfc-input-wrapper mfc-form-input-wrapper--width-popup mu-d-block paraminpopup mfc-form-input-container" :id="'param_'+index" v-for="(item, index) in sqlAdapterDTO.sqlParameterTypes" :key="index" :label="item.fieldName">
                                        <label :for="'param_' + index">{{item.fieldName}}</label>
                                        <input type="text" value="" class="mu-mb-02" :id="'param_' + index">
                                        <div class="mfc-help-text"></div>

                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="mcc-card mcc-card--danger-soft" id="testResultAlertError" v-if="testAdapterResultError == true && sqlTestResult != ''">
                            <div class="mcc-card__header">
                                <h2 class="mcc-card__title" v-if="sqlTestResult != ''">Result</h2>
                            </div>
                            <div class="mcc-card__body">
                                <span id="sqlresultMsg">{{sqlTestResult}}</span>
                            </div>
                        </div>

                        <div class="mcc-row" v-show="fetchGridData">
                            <div class="mcc-col colSpinner">
                                <div class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="mcc-row" v-show="!fetchGridData">
                            <div class="mcc-col mcc-col-md-12">
                                <div style="position:relative">
                                    <div class="mcc-row">
                                        <div class="mcc-col">
                                            <mcc-data-table ref="resultDataTable" id="resultDataTable"></mcc-data-table>

                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>
                    </form>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced mu-mt-04">
                        <button type="button" class="mcc-button mcc-button--outline" v-show="!disableButton" @click="$refs.testAdapterDialog.close()">Cancel</button>
                        <button type="button" class="mcc-button mcc-button--primary" v-show="!disableButton" id="testAdapterBtn" @click="testAdapter(false)" title="Test adapter">
                            <span class="mcc-button__label">Test adapter</span>
                        </button>
                        <button type="button" class="mcc-button mcc-button--outline" v-show="disableButton" @click="$refs.testAdapterDialog.close()">Close</button>
                    </div>
                </div>

            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import sqlAdapterAPI from "../../../services/SqlAdapterAPI";
import Table from "@advanced/component-mosaic-table";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "SqlAdapterEdit",
    data() {
        return {
            sqlAdapterDTO: {
                sqlParameterTypes: [],
                inputParameters: []
            },
            updateCall: true,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            helpTextCreate: constantMessages.BREADCRUMB_HELP["sqladapter.create"],
            helpTextEdit: constantMessages.BREADCRUMB_HELP["sqladapter.edit"],
            dataLoaded: false,
            copyAdapter: false,
            copyAdapterId: this.$route.query.copyAdapterId,
            fetchCall: true,
            isEditPage: false,
            externalSystemId: this.$route.params.externalSystemId,
            externalSystem: {},
            externalSystemAPI: {},
            sqlAdapterName: "",
            sqladapterId: this.$route.params.sqladapterId,
            params: [],
            sqlTestResult: "",
            fetchGridData: false,
            currentPageSize: 10,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"],
            dialogColor: '',
            disableButton: false,
            testAdapterResultError: '',
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        let pageTitle;
        self.isEditPage = self.sqladapterId != null && self.sqladapterId != "new";

        sqlAdapterAPI
            .getAPIInfo(self.$route.params.externalSystemId, self.$route.params.apiId)
            .then(response => {
                if (response != null) {
                    self.externalSystem = response.externalSystemAPI.externalSystem;
                    self.externalSystemAPI = response.externalSystemAPI;
                    self.isReadOnly = self.externalSystem.readOnly;
                    self.sqlAdapterDTO = response.sqlApiAdapter;
                    if (!self.isEditPage) {
                        pageTitle = constantMessages.PAGEHEADER_TITLE["menu.databaseadapter.details"] + " - Create new";
                        EventBus.$emit("update-pageTitle", pageTitle);
                    }
                }
            });

        let editObj;
        if (self.isEditPage || self.copyAdapterId != null) {
            self.fetchCall = false;
            let adapterId = self.sqladapterId;
            if (self.copyAdapterId != null) {
                self.isEditPage = false;
                self.copyAdapter = true;
                adapterId = self.copyAdapterId;
            }
            sqlAdapterAPI
                .getAdapterInfo(
                    self.externalSystemId,
                    self.$route.params.apiId,
                    adapterId
                )
                .then(response => {
                    if (response != null) {
                        editObj = response;
                        self.sqlAdapterName = response.name;
                        self.dataLoaded = true;
                    }
                    pageTitle = constantMessages.PAGEHEADER_TITLE["menu.databaseadapter.details"] + " - " + self.sqlAdapterName;
                    EventBus.$emit("update-pageTitle", pageTitle);
                })
                .finally(function () {
                    self.fetchCall = true;
                    setTimeout(() => {
                        self.setAdapterData(editObj);
                    }, 500);
                });
        }
    },
    methods: {
        openTestAdapter() {
            this.$refs.failedSqlAdapter.close();
            this.$refs.testAdapterDialog.show();
        },
        closetestAdapterDialog() {
            this.$refs.testAdapterDialogFormRef.reset();
            this.$refs.testAdapterDialog.close();
        },
        setAdapterData(editObj) {
            let self = this;
            self.sqlAdapterDTO = editObj;
            self.$refs.name.value = editObj.name;
            self.$refs.adapterPrefix.value = editObj.adapterPrefix;
            self.$refs.sqlMethod.checked = editObj.sqlMethod;
            $("#sql")[0].setAttribute("value", editObj.sql);
            //self.$refs.sql.value = editObj.sql;
            if (self.copyAdapterId != null) {
                self.sqlAdapterDTO.id = null;
                self.sqlAdapterDTO.name = self.sqlAdapterDTO.name + " - copy";
                if (self.sqlAdapterDTO.name.length > 50) {
                    self.sqlAdapterDTO.name = self.sqlAdapterDTO.name.substring(0, 50);
                }
                if (self.copyAdapter) {
                    self.updateParamsCopy();
                }
            }
        },
        exportAdapter() {
            ImportExportAPI.exportFiles("SQLADAPTER", this.sqladapterId);
        },
        testAdapter(isFieldsEmpty) {
            let self = this;
            self.fetchGridData = true;
            self.sqlTestResult = "";
            $("#resultDataTable").html("");
            self.testAdapterResultError = "";

            if (!isFieldsEmpty) {
                self.params = [];
                $(".paraminpopup").each(function (key, ele) {
                    let label = $(ele).find('label').text();
                    let value = $(ele).find('input').val();
                    let obj = {
                        key: label,
                        value: value
                    };
                    self.params.push(obj);
                });

                let paramsObj = JSON.parse(JSON.stringify(self.params));
                self.sqlAdapterDTO.inputParameters = paramsObj;
            }

            sqlAdapterAPI
                .testAdapter(
                    self.sqlAdapterDTO,
                    self.$route.params.externalSystemId,
                    self.$route.params.apiId
                )
                .then(responseData => {
                    if (responseData != null) {
                        let header = responseData.message;
                        if (header === "UPDATE") {
                            self.sqlTestResult = responseData.data;
                            self.fetchGridData = false;
                        } else {
                            if (responseData.error === true) {
                                self.dialogColor = 'danger';
                                self.testAdapterResultError = true;
                                self.sqlTestResult = responseData.data;

                                self.fetchGridData = false;
                            } else {
                                self.disableButton = true;
                                self.dialogColor = 'success'
                                if (header === null || header === "") {
                                    self.sqlTestResult =
                                        constantMessages.MESSAGES[responseData.data];
                                    self.fetchGridData = false;
                                } else {

                                    self.initResultTable(responseData);
                                }
                            }
                        }
                    }
                }).finally(function () {
                    if (isFieldsEmpty) {
                        self.$refs.failedSqlAdapter.show()
                    }
                });;
        },
        initResultTable(responseData) {
            let self = this;

            let prop = [];

            let header = responseData.message.substr(1).slice(0, -1);
            let column_names = header.split(",");
            let str = responseData.data
                .replace(/\\n/g, "\\n")
                .replace(/\\'/g, "\\'")
                .replace(/\\"/g, '\\"')
                .replace(/\\&/g, "\\&")
                .replace(/\\r/g, "\\r")
                .replace(/\\t/g, "\\t")
                .replace(/\\b/g, "\\b")
                .replace(/\\/g, "\\")
                .replace(/\\f/g, "\\f");
            let json = JSON.parse(str);

            $.each(column_names, function (i, value) {
                prop[column_names[i].trim()] = {
                    type: "string",
                    title: column_names[i].trim(),
                    sortable: false,
                    columnSearch: false
                };
            });

            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }

            this.tableObj = window.tableFactory.create(document.getElementById("resultDataTable"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No data found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: 10,
                fixedHeight: true,
                debounceTime: 1000,
                schema: {
                    properties: prop
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    let resultArray = [];
                    let dataArray = {};

                    $.each(json, function (i, row) {
                        let colNameCount = 0;
                        dataArray = [];
                        $.each(json[i], function (j, row) {
                            dataArray[column_names[colNameCount].trim()] = json[i][j];
                            colNameCount = colNameCount + 1;
                            if (colNameCount == column_names.length) {
                                resultArray.push(dataArray);
                                return false;
                            }
                        });
                    });
                    return {
                        totalCount: resultArray.length,
                        data: resultArray
                    };
                },
                onAfterDataLoad: (start, limit) => {
                    self.fetchGridData = false;
                }
            });
        },
        redirectToFileAPI() {
            let self = this;
            localStorage.setItem("APIList", "APIList");
            self.$router.push(
                self.CONTEXT_PATH +
                "/integrate/externalsystems/" +
                self.externalSystemId +
                "/apis/" +
                self.externalSystemAPI.id
            );
        },
        updateParamsCopy() {
            let self = this;
            let updatedSqlParameterTypes = [];
            let existingParamTypes = self.sqlAdapterDTO.sqlParameterTypes;
            if (existingParamTypes != null) {
                $.each(existingParamTypes, function (key, value) {
                    updatedSqlParameterTypes.push({
                        fieldName: value.fieldName,
                        fieldType: value.fieldType,
                        id: null,
                        mandatory: value.mandatory,
                        version: 0,
                        deleted: null,
                        sqlApiAdapter: null
                    });
                });
            }
            self.sqlAdapterDTO.sqlParameterTypes = updatedSqlParameterTypes;
        },
        updateParams(event) {
            setTimeout(() => {
                let self = this;
                self.sqlAdapterDTO.sql = event.target.value;
                let updatedSqlParameterTypes = [];
                let existingParamTypes = self.sqlAdapterDTO.sqlParameterTypes;
                self.sqlAdapterDTO.sqlParameterTypes = [];
                let sqlData = event.target.value;
                let re = /{{([^}]+)}}/g;
                let text;
                while ((text = re.exec(sqlData))) {
                    let type = "STRING";
                    let mandatory = false;

                    $.each(existingParamTypes, function (key, value) {
                        if (value.fieldName == text[1]) {
                            type = value.fieldType;
                            mandatory = value.mandatory;

                        }
                    });
                    updatedSqlParameterTypes.push({
                        fieldName: text[1],
                        fieldType: type,
                        mandatory: mandatory,
                        id: null,
                        version: 0,
                        deleted: null,
                        sqlApiAdapter: null
                    });
                }
                self.sqlAdapterDTO.sqlParameterTypes = updatedSqlParameterTypes;
            }, 0);
        },
        saveSQLAdpater() {
            let form = $('#sqlAdapterForm')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            let adapterObj = {};
            adapterObj.id = self.sqlAdapterDTO.id;
            adapterObj.name = self.sqlAdapterDTO.name;
            adapterObj.nameLowercase = self.sqlAdapterDTO.name.toLowerCase();
            adapterObj.adapterPrefix = self.sqlAdapterDTO.adapterPrefix;
            adapterObj.sqlMethod = self.sqlAdapterDTO.sqlMethod;
            adapterObj.sql = self.sqlAdapterDTO.sql;
            adapterObj.sqlParameterTypes = self.sqlAdapterDTO.sqlParameterTypes;
            adapterObj.externalSystemAPI = self.$route.params.apiId;
            self.updateCall = false;
            sqlAdapterAPI
                .saveSQLAdapter(
                    adapterObj,
                    self.$route.params.externalSystemId,
                    self.$route.params.apiId
                )
                .then(response => {
                    self.updateCall = true;
                    if (response.error) {
                        for (let k in response.messages) {
                            if (k == "name") {
                                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.name.classList.add("ms-is-invalid")
                            } else if (k == "prefix") {
                                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.adapterPrefix.classList.add("ms-is-invalid")
                            } else if (k == "sql") {
                                displayErrorMessage($(self.$refs.sql), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.sql.classList.add("ms-is-invalid")
                            } else if (k == "type") {
                                displayErrorMessage($(self.$refs.sqlMethod), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.sqlMethod.classList.add("ms-is-invalid")
                            }
                        }
                    } else {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        if (!self.isEditPage) {
                            self.$router.push(
                                self.CONTEXT_PATH +
                                "/integrate/externalsystems/" +
                                self.externalSystem.id +
                                "/apis/" +
                                self.$route.params.apiId +
                                "/sqladapters/" +
                                response.data.id
                            );
                        } else {
                            self.sqlAdapterName = response.data.name;
                            self.sqlAdapterDTO = response.data;
                        }
                    }
                });
        },
        deleteSqlAdapter(e) {
            let self = this;
            self.updateCall = false;
            sqlAdapterAPI
                .deleteSqlAdapter(
                    self.$route.params.externalSystemId,
                    self.$route.params.apiId,
                    self.sqlAdapterDTO.id
                )
                .then(response => {
                    self.updateCall = true;
                    if (response != null && !response.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.$router.push(
                            self.CONTEXT_PATH +
                            "/integrate/externalsystems/" +
                            self.externalSystemId +
                            "/apis/" +
                            self.$route.params.apiId
                        );
                    }
                });
        },
        showTestAdapterDialog() {

            if (this.sqlAdapterDTO.sqlParameterTypes.length != 0) {
                this.dialogColor = 'primary'
                this.dialogClass = "mcc-dialog mcc-dialog--primary mcc-dialog--sm";
                self.params = [];
                this.fetchGridData = false;
                $(".paraminpopup").val(" ");
                $(".paraminpopup").val("");
                $("#resultDataTable").html("");
                this.sqlTestResult = "";
                $('.mcc-accordion.mcc-card').attr("open", true);
                self.testAdapterResultError = "";
                $("#testAdapterDialog")[0].show();

            } else {
                this.testAdapter(true)

            }
        },

        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.sqlAdapterDTO.name = event.target.value;
        },
        updatePrefix(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.required"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.length"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.adapterPrefix), constantMessages.MESSAGES["error.prefix.invalid"])
                self.$refs.adapterPrefix.classList.add("ms-is-invalid")
            } else {
                self.$refs.adapterPrefix.classList.remove("ms-is-invalid")
            }
            self.sqlAdapterDTO.adapterPrefix = event.target.value;
        },
        showDeleteAdapterDialog() {
            $("#deleteSqlAdapter")[0].show();
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(this.CONTEXT_PATH + "/integrate/externalsystems");
        }
    }
};
</script>
